/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link, useParams } from 'react-router-dom';
import Marquee from 'react-fast-marquee';
import { dataLayerPush } from '../helpers/dataLayer';
import { Footer, Navbar, Breadcrumb, Rating } from '../components';
import { addItemToLocalStorage } from '../helpers/handleCartLocalStorage';

const Product = () => {
  const { id } = useParams();
  const [product, setProduct] = useState({});
  const [similarProducts, setSimilarProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [state, setState] = useState(localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []);

  const addProduct = (product) => {
    addItemToLocalStorage(product);
    setState(JSON.parse(localStorage.getItem('cart')));
    dataLayerPush({
      event: 'addToCart',
      pageName: 'product',
      pageType: 'detail',
      product: product,
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const getProduct = async () => {
      try {
        setLoading(true);
        setLoading2(true);

        const response = await fetch('/product.json', {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        });

        const data = await response.clone().json();
        setLoading(false);

        // Assuming id is defined somewhere in your component
        const filteredData = data.filter((item) => item.id === parseInt(id));

        if (filteredData.length > 0) {
          setProduct(filteredData[0]);
        }

        setSimilarProducts(data);
        setLoading2(false);
      } catch (error) {
        // Handle any fetch errors here
      }
    };

    getProduct();
    // Avoid setting dataLayerPush in this useEffect, as it may trigger a re-render.
    // Instead, create a separate useEffect for it.
  }, [id]); // Add dependencies if needed

  // Use a separate useEffect for dataLayerPush to avoid re-renders
  useEffect(() => {
    if (product.id) {
      dataLayerPush({
        event: 'pageView',
        pageType: 'detail',
        pageName: 'product',
        product: {
          id: product.id,
          name: product.title,
          price: product.price,
          category: product.category,
          subCategory: product.sub,
        },
      });
    }
  }, [product]);

  const Loading = () => {
    return (
      <>
        <div className='container my-5 py-2'>
          <div className='row'>
            <div className='col-md-6 py-3'>
              <Skeleton height={400} width={400} />
            </div>
            <div className='col-md-6 py-5'>
              <Skeleton height={30} width={250} />
              <Skeleton height={90} />
              <Skeleton height={40} width={70} />
              <Skeleton height={50} width={110} />
              <Skeleton height={120} />
              <Skeleton height={40} width={110} inline={true} />
              <Skeleton className='mx-3' height={40} width={110} />
            </div>
          </div>
        </div>
      </>
    );
  };

  const ShowProduct = () => {
    return (
      <>
        <div className='container my-5 py-2'>
          <Breadcrumb category={product.category} title={product.title} />
          <div className='row'>
            <div className='col-md-6 col-sm-12 py-3 text-center m-auto'>
              <div className='row'>
                <div className='col-sm-8'>
                  <img
                    className='img-fluid h-100'
                    key={product.id}
                    src={`${product?.images?.main}`}
                    alt={product.title}
                  />
                </div>
                <div className='col-sm-3'>
                  {product?.images?.alt.map((img) => (
                    <img className='img-fluid mb-1' key={product.id} src={`${img}`} alt={product.title} />
                  ))}
                </div>
              </div>
            </div>
            <div className='col-md-6 col-md-6'>
              <p className='mt-2 fs-4 fw-light'>{product.title}</p>
              <p className='lead'>
                <Rating rating={product.rating && product.rating.rate} />
                {/* {product.rating && product.rating.rate} <i className='fa fa-star'></i> */}
              </p>
              <h3 className='my-4'>${product.price}</h3>
              <div className='row mb-4'>
                <div className='col-sm-6'>
                  <button
                    className='btn btn-dark addToCart w-100'
                    onClick={(e) => {
                      e.preventDefault();
                      addProduct(product);
                    }}>
                    Add to Cart
                  </button>
                </div>
                <div className='col-sm-6'>
                  <a
                    href='/cart'
                    className='btn text-decoration-underline addToCart w-100'
                    style={{ background: '#fff' }}>
                    Go to Cart
                  </a>
                </div>
              </div>
              <hr />
              <div className='opacity-75 mt-4'>
                <p className='text-uppercase mb-2'>Product Features</p>
                <p>{product.description}</p>
                <p className='text-uppercase mb-2'>Fabric Details</p>
                <p>{product.fabric_details}</p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const Loading2 = () => {
    return (
      <>
        <div className='my-4 py-4'>
          <div className='d-flex'>
            <div className='mx-4'>
              <Skeleton height={400} width={250} />
            </div>
            <div className='mx-4'>
              <Skeleton height={400} width={250} />
            </div>
            <div className='mx-4'>
              <Skeleton height={400} width={250} />
            </div>
            <div className='mx-4'>
              <Skeleton height={400} width={250} />
            </div>
          </div>
        </div>
      </>
    );
  };

  const ShowSimilarProduct = () => {
    return (
      <>
        <div className='py-4 my-4'>
          <div className='d-flex'>
            {similarProducts.map((item) => {
              return (
                <div key={item.id} className='mx-4 text-center'>
                  <img className='card-img-top p-3' src={`${item?.images?.main}`} alt='Card' height={300} width={300} />
                  <div className='card-body'>
                    <h5 className='card-title'>{item.title.substring(0, 15)}...</h5>
                  </div>
                  <ul className='list-group list-group-flush'>
                    <li className='list-group-item lead'>${product.price}</li>
                  </ul>
                  <div className='card-body'>
                    <Link to={'/product/' + item.id} className='btn btn-dark m-1 addToCart'>
                      Buy Now
                    </Link>
                    <button className='btn text-decoration-underline m-1 addToCart' onClick={() => addProduct(item)}>
                      Add to Cart
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <Navbar />
      <div className='container'>
        <div className='row'>{loading ? <Loading /> : <ShowProduct />}</div>
        <div className='row my-5 py-5'>
          <div className='d-none d-md-block'>
            <h2 className=''>You may also Like</h2>
            <Marquee pauseOnHover={true} pauseOnClick={true} speed={50}>
              {loading2 ? <Loading2 /> : <ShowSimilarProduct />}
            </Marquee>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Product;
